module.exports = __webpack_public_path__ + "static/media/solviablack.b6032a0d.png";